import { tokens, Title } from '@arvoreeducacao/bonsai-ds'
import ShelfBackground from 'components/shelf-background'
import styled from 'styled-components'

export const EnglishLevelWrapper = styled(ShelfBackground).attrs({
  color: tokens.colors.tertiaryLight
})`
  margin-bottom: 68px;
  margin-top: ${tokens.spacing.verticalXlarge};
  padding-bottom: 26px;
`

export const StyledTitle = styled(Title)`
  margin-left: 18px;

  @media (min-width: ${tokens.sizes.smScreen}px) {
    margin-left: 8px;
  }
`

export const StyledEnglishLevelHeader = styled.div`
  display: flex;
  flex-direction: column;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`
